import { Table } from 'antd'
import React from 'react'

const TableCustomerEmail = ({ dataSource }) => {

  const columns = [
    {
      key: 'Email',
      title: 'Email',
      dataIndex: 'Email',
    },
    {
      key: 'ContactName',
      title: 'Contact Name',
      dataIndex: 'ContactName',
    },
    {
      key: 'Authority',
      title: 'Authority',
      dataIndex: 'Authority',
    },
  ];


  return (
    <div>
      <h1 className="border-b-2 pb-1 text-xl mb-2">Customer Email</h1>
      <Table
        bordered
        columns={columns}
        dataSource={dataSource}
        scroll={{
          x: 'max-content',
        }}
      />
    </div>
  )
}

export default TableCustomerEmail